/**
 * Point Draw rebuilds path geometry without inventing new track identities.
 * Rebuilt pieces reuse the in-progress session rails in path order; only extra
 * pieces take a new TRACK / Rail number.
 */

export function pairRebuildPieces<T, TReuse>(
  pieces: T[],
  reusable: TReuse[]
): Array<{ piece: T; reuse?: TReuse }> {
  return pieces.map((piece, index) => ({
    piece,
    reuse: reusable[index],
  }));
}

export function sessionRailsForRebuild<T extends { id: string }>(
  sessionIds: readonly string[],
  elements: Record<string, T | undefined>,
  skipLeadingCount = 0
): T[] {
  return sessionIds
    .slice(Math.max(0, skipLeadingCount))
    .map((id) => elements[id])
    .filter((el): el is T => !!el);
}
